// extracted by mini-css-extract-plugin
export var buttonClean = "PaginatedCollectionFluid-module--buttonClean--9aabb";
export var card = "PaginatedCollectionFluid-module--card--1896d";
export var entriesContainer = "PaginatedCollectionFluid-module--entriesContainer--68364";
export var entriesGroup = "PaginatedCollectionFluid-module--entriesGroup--317f1";
export var initialButton = "PaginatedCollectionFluid-module--initialButton--8cc69";
export var initialGroup = "PaginatedCollectionFluid-module--initialGroup--2f446";
export var navButtonsContainer = "PaginatedCollectionFluid-module--navButtonsContainer--453b0";
export var paginatedCollectionContainer = "PaginatedCollectionFluid-module--paginatedCollectionContainer--50de5";